import { render, staticRenderFns } from "./ProcessingBatchBulkImportHistory.vue?vue&type=template&id=496c3266&scoped=true"
import script from "./ProcessingBatchBulkImportHistory.vue?vue&type=script&lang=js"
export * from "./ProcessingBatchBulkImportHistory.vue?vue&type=script&lang=js"
import style0 from "./ProcessingBatchBulkImportHistory.vue?vue&type=style&index=0&id=496c3266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496c3266",
  null
  
)

export default component.exports